export default "__VITE_ASSET__8cm6DBOd__"